import { render, staticRenderFns } from "./PlayersGrid.vue?vue&type=template&id=6ab883be"
import script from "./PlayersGrid.vue?vue&type=script&lang=js"
export * from "./PlayersGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports